var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoplusrenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.642,
    height: 50,
    viewBox: "0 0 158.642 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132671",
    "data-name": "Group 132671",
    transform: "translate(-603 -570)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132505",
    "data-name": "Group 132505",
    transform: "translate(704.081 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95936",
    "data-name": "Path 95936",
    d: "M6.245,50h45.2a6.106,6.106,0,0,0,6.117-6.149V28.27a6.161,6.161,0,0,0-6.117-6.213H49.557L32.967,6.535a4.513,4.513,0,0,0,.449-1.967,4.571,4.571,0,1,0-9.143.006,4.481,4.481,0,0,0,.449,1.96L8.132,22.057H6.245A6.271,6.271,0,0,0,0,28.27V43.851A6.216,6.216,0,0,0,6.245,50Zm22.6-47.935a2.511,2.511,0,1,1-2.511,2.511A2.511,2.511,0,0,1,28.844,2.065ZM26.015,8.147a4.522,4.522,0,0,0,5.659,0L46.542,22.057h-35.4ZM55.5,43.819a4.121,4.121,0,0,1-4.121,4.121H6.181A4.121,4.121,0,0,1,2.06,43.819V28.238a4.121,4.121,0,0,1,4.121-4.121h45.2A4.121,4.121,0,0,1,55.5,28.238Zm0,0",
    transform: "translate(0 0)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95937",
    "data-name": "Path 95937",
    d: "M1.025,12.526H2.808V8.743H3.57c1.456,0,2.1.68,2.164,1.892.041.721.109,1.47.177,1.892H7.993a4.987,4.987,0,0,1-.435-1.973A2.542,2.542,0,0,0,6.441,8.5a2.714,2.714,0,0,0,1.647-2.64A2.935,2.935,0,0,0,5.121,3h-4.1ZM2.808,7.192V4.715h2.15A1.275,1.275,0,0,1,6.292,5.953,1.275,1.275,0,0,1,4.958,7.192ZM10.1,12.526h5.811v-1.7H11.885V8.43h3.606V6.715H11.885V4.7h4.028V3H10.1Zm7.893,0h1.783V8.1c0-1.2-.082-2.191-.082-2.191s.463.885,1.116,1.878l3.212,4.736h1.511V3H23.752V7.423c0,1.211.082,2.2.082,2.2a21.325,21.325,0,0,0-1.116-1.892L19.52,3H18Zm11.908,0h1.8V4.7h2.667V3H27.236V4.7H29.9Z",
    transform: "translate(11.458 28.804)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132490",
    "data-name": "Group 132490",
    transform: "translate(670.069 585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95933",
    "data-name": "Path 95933",
    d: "M-9209.957-10370.245v19.013",
    transform: "translate(9219.464 10370.245)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95934",
    "data-name": "Path 95934",
    d: "M0,0V19.012",
    transform: "translate(19.012 9.506) rotate(90)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(603 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91190",
    "data-name": "Path 91190",
    d: "M15.5,2.08H33.066c3.154,0,5.433.763,6.968,2.333A10.453,10.453,0,0,1,42.47,9.794L45.3,23.331a1.019,1.019,0,0,1-1,1.228H4.269a1.019,1.019,0,0,1-1-1.228L6.1,9.8A10.455,10.455,0,0,1,8.535,4.413C10.07,2.843,12.349,2.08,15.5,2.08ZM43.046,22.521,40.475,10.213a8.7,8.7,0,0,0-1.9-4.375c-1.131-1.157-2.934-1.72-5.51-1.72H15.5c-2.577,0-4.379.563-5.51,1.72a8.7,8.7,0,0,0-1.9,4.376L5.523,22.521Z",
    transform: "translate(1.75 -2.08)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91191",
    "data-name": "Path 91191",
    d: "M47.2,39.809H42.5c-3.428,0-4.031-1.808-4.515-3.261l-.514-1.54c-.672-1.968-.923-2.7-3.778-2.7H20.881a4.05,4.05,0,0,0-2.794.732,4.8,4.8,0,0,0-.993,2l-.5,1.514C16.106,38,15.5,39.809,12.075,39.809h-4.7a6.175,6.175,0,0,1-4.561-2,5.968,5.968,0,0,1-1.533-4.565l1.4-15.235c.178-1.9.457-3.883,1.724-5.386C5.766,11,7.966,10.25,11.324,10.25H43.248c3.358,0,5.558.753,6.921,2.37A9.407,9.407,0,0,1,51.894,18l1.4,15.238a5.967,5.967,0,0,1-1.533,4.563A6.175,6.175,0,0,1,47.2,39.809Zm-26.32-9.544h12.81c4.312,0,4.99,1.984,5.707,4.085l.011.033,0,.007.5,1.514a3.431,3.431,0,0,0,.674,1.4,2.812,2.812,0,0,0,1.907.472h4.7a4.132,4.132,0,0,0,3.053-1.338,3.874,3.874,0,0,0,1.011-3l-1.4-15.239c-.343-3.673-.959-5.9-6.616-5.9H11.324c-5.657,0-6.273,2.231-6.616,5.906l-1.4,15.235a3.875,3.875,0,0,0,1.011,3,4.132,4.132,0,0,0,3.053,1.338h4.7a2.812,2.812,0,0,0,1.907-.472,3.431,3.431,0,0,0,.674-1.4l.5-1.514C15.805,32.456,16.536,30.265,20.881,30.265Z",
    transform: "translate(-1.252 10.191)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91192",
    "data-name": "Path 91192",
    d: "M5.771,9.288h-2.5a1.019,1.019,0,0,1,0-2.038h2.5a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(0.248 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91193",
    "data-name": "Path 91193",
    d: "M22.771,9.288h-2.5a1.019,1.019,0,1,1,0-2.038h2.5a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(25.781 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91194",
    "data-name": "Path 91194",
    d: "M12.269,9.292A1.019,1.019,0,0,1,11.25,8.273v-5a1.019,1.019,0,0,1,2.038,0v5A1.019,1.019,0,0,1,12.269,9.292Z",
    transform: "translate(13.765 -1.825)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91195",
    "data-name": "Path 91195",
    d: "M18.275,6.288H10.769a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(11.512 1.179)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91196",
    "data-name": "Path 91196",
    d: "M13.775,16.288H6.269a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(4.754 16.198)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91197",
    "data-name": "Path 91197",
    d: "M22.775,16.288H15.269a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(18.271 16.198)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplusrenters);
export default __webpack_public_path__ + "static/media/autoplusrenters.2676f09f95d4c2ff8d9034ca37468069.svg";
export { ForwardRef as ReactComponent };